import {Component, Object3D} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {ActiveCamera} from './active-camera.js';
import {quat, vec3} from 'gl-matrix';

const tempVec3 = vec3.create();
const tempQuat = quat.create();

export class CursorBillboard extends Component {
    static TypeName = 'cursor-billboard';

    @property.object({required: true})
    player!: Object3D;
    headObject: Object3D | undefined;

    start() {
        const activeCameraComponent = this.player.getComponent(ActiveCamera);
        if (!activeCameraComponent) {
            throw new Error(
                `inspect-note(${this.object.name}): player does not have an ActiveCamera component`
            );
        }
        this.updateHeadObject();
    }

    onActivate(): void {
        this.engine.onXRSessionStart.add(this.updateHeadObject);
        this.engine.onXRSessionEnd.add(this.updateHeadObject);
    }

    onDeactivate(): void {
        this.engine.onXRSessionStart.remove(this.updateHeadObject);
        this.engine.onXRSessionEnd.remove(this.updateHeadObject);
    }

    updateHeadObject = () => {
        this.headObject = this.player.getComponent(ActiveCamera)?.getActiveCamera();
    };

    update() {
        this.headObject!.getPositionWorld(tempVec3);
        // //this.object.resetRotation();
        this.object.getRotationWorld(tempQuat);
        this.object.lookAt(tempVec3, [0, 1, 0]);
        this.object.rotateAxisAngleDegObject([0, 1, 0], 180);
        // this.object.rotateAxisAngleDegLocal([1, 0, 0], -90);
    }
}
